var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeef(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "beef1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "beef2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "beef3",
    d: "M37.8,97A24.234,24.234,0,0,1,15.345,82.679a27.086,27.086,0,0,1-2.152-7.985A29.379,29.379,0,0,1,13,71.3C13,45.312,30.047,31,61,31c20.833,0,43.315,10.447,51.183,23.784a18.591,18.591,0,0,1,1.081,17.7c-2.3,4.665-6.625,7.233-12.181,7.233a22.715,22.715,0,0,1-7.77-1.5,20.291,20.291,0,0,0-7.136-1.378c-7.131,0-15.043,4.395-30.081,14.244A33.69,33.69,0,0,1,37.8,97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "beef3",
    d: "M61,33c21.15,0,42.31,10.68,49.46,22.8a16.594,16.594,0,0,1,1.01,15.8c-1.947,3.948-5.629,6.117-10.387,6.117A20.742,20.742,0,0,1,94,76.34a22.409,22.409,0,0,0-7.824-1.5c-7.857,0-16.114,4.7-31.176,14.57A31.489,31.489,0,0,1,37.8,95,22.139,22.139,0,0,1,17.17,81.86a25.085,25.085,0,0,1-1.99-7.39A27.42,27.42,0,0,1,15,71.3C15,45.09,33,33,61,33m0-4c-15.293,0-27.4,3.425-35.974,10.178C15.719,46.506,11,57.313,11,71.3a31.522,31.522,0,0,0,.207,3.633,29.058,29.058,0,0,0,2.308,8.552A26.216,26.216,0,0,0,37.8,99a35.678,35.678,0,0,0,19.39-6.244C71.884,83.133,79.555,78.84,86.176,78.84A18.363,18.363,0,0,1,92.624,80.1a24.708,24.708,0,0,0,8.459,1.621c6.266,0,11.359-3.043,13.975-8.348A20.592,20.592,0,0,0,113.9,53.762c-3.942-6.683-11.476-12.907-21.208-17.522A75.572,75.572,0,0,0,61,29Z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    className: "beef4",
    d: "M110.46,55.8a16.594,16.594,0,0,1,1.01,15.8c-3.11,1.41-7.7,1.41-14.47-1.6-18-8-32,5-46,14-11.11,7.14-25.8,5.08-33.83-2.14a25.086,25.086,0,0,1-1.99-7.39A27.421,27.421,0,0,1,15,71.3C15,45.09,33,33,61,33,82.15,33,103.31,43.68,110.46,55.8ZM50,64a9,9,0,1,0-9,9A9,9,0,0,0,50,64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "beef5",
    cx: 41,
    cy: 64,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "beef6",
    d: "M55,89.41c-16.06,10.52-32.12,5.17-37.83-7.55C25.2,89.08,39.89,91.14,51,84c14-9,28-22,46-14,6.77,3.01,11.36,3.01,14.47,1.6-2.83,5.74-9.33,7.72-17.47,4.74C83,72.31,75,76.31,55,89.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "beef7",
    d: "M113,64.24a16.579,16.579,0,0,1-1.53,7.36c-3.11,1.41-7.7,1.41-14.47-1.6-18-8-32,5-46,14-11.11,7.14-25.8,5.08-33.83-2.14a25.085,25.085,0,0,1-1.99-7.39,10.144,10.144,0,0,1,3.77.96,38.133,38.133,0,0,1,4.29,2.76c7.05,4.66,17.08,5.42,23.76.23,5.23-4.06,8.37-11.38,14.86-12.69,1.93-.39,3.94-.16,5.89-.46,4.81-.74,8.69-4.57,13.47-5.46,3.83-.72,7.71.53,11.48,1.5a84.14,84.14,0,0,0,13.37,2.28,3.358,3.358,0,0,0,1.89-.22,2.96,2.96,0,0,0,1-1.13,11.351,11.351,0,0,0,1.5-6.44A16.616,16.616,0,0,1,113,64.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "beef8",
    d: "M17.17,81.86a25.086,25.086,0,0,1-1.99-7.39A27.421,27.421,0,0,1,15,71.3C15,45.09,33,33,61,33c21.15,0,42.31,10.68,49.46,22.8a16.594,16.594,0,0,1,1.01,15.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "beef8",
    cx: 41,
    cy: 64,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "beef8",
    d: "M111.47,71.6c-2.83,5.74-9.33,7.72-17.47,4.74-11-4.03-19-.03-39,13.07-16.06,10.52-32.12,5.17-37.83-7.55C25.2,89.08,39.89,91.14,51,84c14-9,28-22,46-14C103.77,73.01,108.36,73.01,111.47,71.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "beef9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "beef8",
    x1: 68,
    y1: 45,
    x2: 81.5,
    y2: 58.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "beef8",
    x1: 52,
    y1: 43,
    x2: 65.5,
    y2: 56.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "beef8",
    x1: 84,
    y1: 47,
    x2: 97.5,
    y2: 60.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeef);
export default __webpack_public_path__ + "static/media/Beef.116ca3128bb178d52529a17338f628f6.svg";
export { ForwardRef as ReactComponent };